import React from 'react';
import PropTypes from 'prop-types';

import { PageSubTitle } from 'components/common/Elements/Elements';
import Cart from './Cart/Cart';
import Csat from './Csat/Csat';
import HealthStatus from './HealthStatus/HealthStatus';

import { chartColor } from '../../helpers/configurates';

import classes from './Widgets.module.scss';

const Widgets = ({ data }) => {
  const openTickets = {
    title: 'Open Tickets',
    contentText: data.openTickets
  };

  const healthScore = {
    title: 'Health Score',
    contentText: data.healthPoint
  };

  const nps = {
    title: 'NPS',
    contentText: data.npsScore
  };

  const csat = {
    title: 'CSAT',
    contentText: {
      csatChatScore: data.csatChatScore,
      csatTicketScore: data.csatTicketScore,
      csatTicketsCount: data.csatTicketsCount,
      csatChatsCount: data.csatChatsCount
    }
  };

  return (
    <section>
      <PageSubTitle hiden title="Satisfaction board widgets" />
      <div className={classes.charts}>
        <HealthStatus data={data.healthStatus} chartColor={chartColor} />
        <Cart data={openTickets} />
        <Cart data={healthScore} />
        <Cart data={nps} />
        <Csat data={csat} />
      </div>
    </section>
  );
};

Widgets.propTypes = {
  data: PropTypes.object
};

export default Widgets;
